<template>
    <v-dialog v-model="getModalExcluirContaReceber" max-width="500px" transition="dialog-transition">
        <v-card>
            <v-card-title>
                Excluir
            </v-card-title>
            <v-card-text>
                <h3 align="center">Tem certeza que deseja excluir?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalExcluirContaReceber(false)" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="excluirContaReceber(getContaReceber)" outlined>Sim</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalExcluirContaReceber',
                'getContaReceber'
            ])
        },
        methods: {
            ...mapActions([
                'setModalExcluirContaReceber',
                'excluirContaReceber'
            ])
        }
    }
</script>